<template>
  <div id="download">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'download'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/download/download.vue